(function () {
    'use strict';

    angular.module("imApp").factory("factoryService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 2027,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2028,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
